/**
 * Route for `bulk-lp-upload`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { BulkLpUploadPage } from "../features/bulk-lp-upload/BulkLpUploadPage";

export const bulkLpUploadRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/bulk-lp-upload",
	component: BulkLpUploadPage,
});

export default bulkLpUploadRoute;
